import { useMemo } from "react";

import { translate } from "app/filters/i18nFilter";
import AnimativeLoadingView from "app/pages/sales-intelligence/common-components/AnimativeLoadingView/AnimativeLoadingView";

export const LoadingView = ({ showText = false }: { showText?: boolean }) => {
    const texts = useMemo(
        () =>
            showText
                ? Array.from(
                      { length: 28 },
                      (_, i) => translate(`si.pages.ai_agent_email.loader.message_${i + 1}`) + "...",
                  )
                : [],
        [showText],
    );

    return <AnimativeLoadingView texts={texts} />;
};
